import React, { useCallback, useMemo, useState } from 'react'

import { FileUploadDishPopup } from './components/FileUploadDishPopup'

import { useNavigate } from 'react-router'

import { useSearchParams } from 'react-router-dom'

import { AppLoader, LoaderType } from 'components/AppLoader'
import { setFullTime } from 'utils/formatDate'

import { ImagePreviewWrapperSizeEnum } from 'shared/ui/ImagePreviewWrapper/ImagePreviewWrapper'

import { useTranslation } from 'react-i18next'
import { useGetWidth } from 'utils/useGetWidth'

import { useDeleteDish } from './hooks/useDeleteDish'
import { useStartParamsDish } from './hooks/useStartParamsDish'
import { useLoadDishesFromSh } from './hooks/useLoadDishesFromSh'
import { useGetBuffetDishData } from './hooks/useGetBuffetDishData'
// import { useSentOnFotobox } from './hooks/useSentOnFotobox'

import { useGetCurrentUserQuery } from 'core/api/UserApi'
import { IBuffetDishDto } from 'core/api/dto/BuffetDishDto'
import { AppBtnColor, AppBtnSize } from 'components/btn/AppBtn'
import { AllRoutes } from 'core/routes/AllRoutes'
import { AppDeletePopup } from 'entities/AppDeletePopup/AppDeletePopup'
import { AppTitlePage } from 'components/AppTitlePage'
import { AppFilterMultiDropdownWithPagination } from 'components/AppDropdown/AppFilterMultiDropdownWithPagination'
import { IBaseSimpleList, IChooseItems } from 'core/api/dto/BaseDto'
import { useGetBuffetDishSimpleListQuery } from 'core/api/BuffetDishApi'
import { useGetCategoryQuery } from 'core/api/CategoryApi'
import { ICategory } from 'core/api/dto/CategoriesObjDto'
import { AppFilterDropdown } from 'components/AppDropdown/AppFilterDropdown'
import { AppTableMobile } from 'components/AppTable/AppTableMobile'
import {
  AppTableAlignType,
  AppTableLink,
} from 'components/AppTable/components/AppTableLink'
import { AppTableNumberBlock } from 'components/AppTable/components/AppTableNumberBlock'
import { AppTableImageViewer } from 'components/AppTableImageViewer/AppTableImageViewer'
export type DishExportType = 'xlsx' | 'csv'
const headerData = [
  { title: 'Наименование', colWidth: '20%', sort: 'name' },
  { title: 'Категория', colWidth: '15%', sort: 'internal_dish_category' },
  { title: 'Статус', colWidth: '8%', sort: 'is_archived' },
  { title: 'Вес Эталонный, кг', colWidth: '10%', sort: 'standard_weight' },
  {
    title: 'Отклонение эталонного веса, кг',
    colWidth: '15%',
    sort: 'standard_deviation',
  },
  {
    title: 'Время реализации, ч:мин',
    colWidth: '12%',
    sort: 'implementation_period',
  },
  {
    title: 'Температура Эталонная, °C',
    colWidth: '10%',
    sort: 'standard_temp_min,standard_temp_max',
  },
  { title: 'Эталонное фото', colWidth: '5%' },
]

const archivedFilterData = [
  { name: 'Активно', value: false },
  { name: 'Удалено', value: true },
]

export const DishesPage = () => {
  const { t } = useTranslation()
  const [, setSearchParams] = useSearchParams()
  const { width } = useGetWidth()

  const {
    buffetDishesData,
    isFetchingGet,
    isLoadingGet,
    pageParams,
    unloadDishesHandler,
    isLoadingLocal,
  } = useGetBuffetDishData()
  const { data: currentUser } = useGetCurrentUserQuery()
  const navigate = useNavigate()
  const [isFiltersOpen, setIsFiltersOpen] = useState(true)
  const [uploadFilePopup, setUploadFilePopup] = useState<boolean>(false)
  const [chooseItems, setChooseItems] = useState<IChooseItems | null>(null)
  const [fileType, setFileType] = useState<DishExportType>('xlsx')
  const {
    deletePopup,
    onDeletePopupHandler,
    onDeleteHandler,
    closeDeletePopup,
  } = useDeleteDish(chooseItems, setChooseItems)
  const setIsLoadDishesFromShHandler = useLoadDishesFromSh()

  const [tableData, setTableData] = useState<IBuffetDishDto[]>([])

  const tableActions = [
    {
      title: 'Удалить',
      ico: 'basket',
      onClick: onDeletePopupHandler,
    },
  ]

  const clearFilterHandler = useCallback(() => {
    setSearchParams('limit=40')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const openUploadFilePopupHandler = useCallback((type: DishExportType) => {
    setFileType(type)
    setUploadFilePopup(true)
  }, [])

  useStartParamsDish(setSearchParams)

  const actions = useMemo(
    () => [
      {
        btnTitle: '',
        btnIco: 'reload',
        sized: AppBtnSize.onlyIco,
        onClick: setIsLoadDishesFromShHandler,
        color: AppBtnColor.violetWhite,
      },
      {
        btnTitle: 'Загрузить',
        btnIco: 'import',
        onClick: () => {},
        disabled:
          currentUser?.userRoles.restaurant.source.sourceType ===
          'EXT_INTEGRATION',
        color: AppBtnColor.whiteOutlineViolet,
        items: [
          {
            title: 'Таблица .XLSX',
            onClick: () => openUploadFilePopupHandler('xlsx'),
            ico: 'file-xlsx',
          },

          {
            title: 'Файл.CSV',
            onClick: () => openUploadFilePopupHandler('csv'),
            ico: 'file-csv',
          },
        ],
      },
      {
        btnTitle: 'Выгрузить',
        btnIco: 'export',
        onClick: unloadDishesHandler,
        color: AppBtnColor.whiteOutlineViolet,
      },
      {
        btnTitle: 'Добавить блюдо',
        btnIco: 'add',
        onClick: () => navigate(AllRoutes.addDishes.path),
        color: AppBtnColor.whiteOutlineViolet,
        disabled:
          currentUser?.userRoles.restaurant.source.sourceType ===
          'EXT_INTEGRATION',
      },
      {
        btnTitle: 'Сбросить фильтр',
        onClick: clearFilterHandler,
        color: AppBtnColor.extraVioletViolet,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [navigate, pageParams, isFiltersOpen, currentUser, unloadDishesHandler],
  )
  if (!buffetDishesData) {
    return null
  }

  return (
    <React.Fragment>
      {isLoadingLocal && <AppLoader loaderType={LoaderType.main} />}
      {uploadFilePopup && (
        <FileUploadDishPopup
          setActive={setUploadFilePopup}
          fileType={fileType}
        />
      )}
      {deletePopup && (
        <AppDeletePopup onClose={closeDeletePopup} onDelete={onDeleteHandler} />
      )}

      <div className={'width-for-page-wrapper'}>
        <AppTitlePage
          title="Блюда"
          actions={actions}
          isFiltersOpen={isFiltersOpen}
          setIsFiltersOpen={setIsFiltersOpen}
        />
        {isFiltersOpen && (
          <div className="filter-block mt-20">
            <div className={width <= 500 ? 'col-4' : ''}>
              <AppFilterMultiDropdownWithPagination<
                IBaseSimpleList,
                keyof IBaseSimpleList
              >
                searchParam={'ids'}
                id={'ids'}
                getterData={useGetBuffetDishSimpleListQuery}
                propToShowInList={'name'}
                valuePropName={'id'}
                label={'Названия блюд'}
                placeholder={'Выбрать'}
                fullWidth
                showArchivedItems={false}
              />
            </div>
            <AppFilterMultiDropdownWithPagination<ICategory, keyof ICategory>
              searchParam={'category_ids'}
              id={'-category_ids'}
              getterData={useGetCategoryQuery}
              propToShowInList={'name'}
              valuePropName={'id'}
              label={'Категория'}
              placeholder={'Выбрать'}
              showArchivedItems={false}
            />

            <AppFilterDropdown
              withTranslate
              id={'-is_archived'}
              searchParam={'is_archived'}
              data={archivedFilterData}
              valuePropName={'value'}
              propToShowInList={'name'}
              label={'Статус'}
              placeholder={'Выбрать'}
              minHeight
            />
          </div>
        )}
        <AppTableMobile
          data={buffetDishesData}
          headerData={headerData}
          chooseActions={tableActions}
          chooseMode
          chooseItems={chooseItems}
          setChooseItems={setChooseItems}
          setTableData={setTableData}
          idName={'dish'}
          tableDataSelectors={[
            {
              renderItem: (item) => {
                return (
                  <AppTableLink
                    path={`${item.id}`}
                    deleteItem={item.isArchived}
                  >
                    <div className="clip-base">{item.name}</div>
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableLink
                    path={`${item.id}`}
                    deleteItem={item.isArchived}
                  >
                    {item?.internalDishCategory?.name}
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return item.isArchived ? (
                  <div className={`table-status delete`}>{t('Удалённый')}</div>
                ) : (
                  <AppTableLink
                    path={`${item.id}`}
                    deleteItem={item.isArchived}
                  >
                    <div className={`table-status`}>{t('Активный')}</div>
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableLink
                    path={`${item.id}`}
                    deleteItem={item.isArchived}
                    align={AppTableAlignType.right}
                  >
                    <AppTableNumberBlock
                      value={
                        item?.standardWeight
                          ?.toFixed(3)
                          .toString()
                          .replace(/[.]/g, ',') || ''
                      }
                    />
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableLink
                    path={`${item.id}`}
                    deleteItem={item.isArchived}
                    align={AppTableAlignType.right}
                  >
                    <AppTableNumberBlock
                      value={
                        item?.standardDeviation
                          ?.toFixed(3)
                          .toString()
                          .replace(/[.]/g, ',') || ''
                      }
                    />
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableLink
                    path={`${item.id}`}
                    deleteItem={item.isArchived}
                    align={AppTableAlignType.right}
                  >
                    {`${
                      item.implementationPeriodRepresent
                        ? setFullTime(item.implementationPeriodRepresent)
                        : ''
                    }`}
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableLink
                    path={`${item.id}`}
                    deleteItem={item.isArchived}
                    align={AppTableAlignType.right}
                  >
                    <React.Fragment>
                      <AppTableNumberBlock
                        isTemp
                        value={item.standardTempMin ?? ''}
                      />{' '}
                      <span className="pl-4 pr-4"> - </span>
                      <AppTableNumberBlock
                        isTemp
                        value={item.standardTempMax ?? ''}
                      />
                    </React.Fragment>
                  </AppTableLink>
                )
              },
            },
            {
              renderItem: (item) => {
                return (
                  <AppTableImageViewer
                    imgPreview={item?.imagePreviewOnS3 || item.imagePreview}
                    image={item?.imageOnS3 || item.image}
                    imageName={item.name}
                    archived={item.isArchived}
                    size={ImagePreviewWrapperSizeEnum.MEDIUM}
                  />
                )
              },
            },
          ]}
          isLoading={isLoadingGet || isFetchingGet}
        />
      </div>
    </React.Fragment>
  )
}
